import React from 'react';

const WizardContext = React.createContext();

export const WrapWizardContext = (ComponentToWrap) =>
    class WrapContext extends React.Component {
        render() {
            return (
                <WizardContext.Consumer>
                    {(context) => {
                        return <ComponentToWrap {...context} {...this.props} />;
                    }}
                </WizardContext.Consumer>
            );
        }
    };

export default WizardContext;
